module.exports = __webpack_public_path__ + "static/media/ahouais.de54571.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ahouais.mp3
// module id = 20
// module chunks = 0